const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '热播榜单', href: '#ranking' },
      { label: '精彩剧集', href: '#media' },
      { label: '分类索引', href: '#index' },
      { label: '话题热议', href: '#topics' },
      { label: '最新更新', href: '#updates' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '平台介绍', href: '#about' },
      { label: '联系我们', href: '#contact' },
      { label: '常见问题', href: '#faq' },
      { label: '用户好评', href: '#comments' },
    ],
  },
  {
    title: '合作伙伴',
    links: [],
  },
];

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-white">
      <div className="w-full px-4 md:px-6 py-14 md:py-16 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <a href="#hero" className="inline-block font-heading text-xl font-bold text-white mb-4 no-underline" onClick={(e) => { e.preventDefault(); handleClick('#hero'); }}>
              天堂影视
            </a>
            <p className="text-sm text-foreground-300 leading-relaxed">
              电视剧全集免费在线观看平台。
              高清画质不缓冲不卡顿，每日更新最新热播剧，
              免广告纯净追剧体验。
            </p>
          </div>

          {footerLinks.map((group, i) => (
            <div key={i}>
              <h4 className="text-sm font-semibold text-white mb-4">{group.title}</h4>
              {group.links.length > 0 ? (
                <ul className="flex flex-col gap-2.5">
                  {group.links.map((link, j) => (
                    <li key={j}>
                      <a
                        href={link.href}
                        onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
                        className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer no-underline"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-foreground-500">更多伙伴即将加入</p>
              )}
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 天堂影视 版权所有 | 本站所有资源均来自网络，仅供学习交流使用
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-foreground-400 hover:text-white transition-colors cursor-pointer" onClick={(e) => { e.preventDefault(); handleClick('#hero'); }}>
              <i className="ri-arrow-up-circle-line text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}